import { useTranslation } from "react-i18next"
import { Loader2 } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface DeleteReportListDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  reportListName: string
  isPending?: boolean
  onConfirm: () => void
}

export function DeleteReportListDialog({
  open,
  onOpenChange,
  reportListName,
  isPending,
  onConfirm,
}: Readonly<DeleteReportListDialogProps>) {
  const { t } = useTranslation()
  const handleConfirm = () => {
    if (!isPending) {
      onConfirm()
    }
  }

  return (
    <Dialog open={open} onOpenChange={isPending ? undefined : onOpenChange}>
      <DialogContent
        className="sm:max-w-[500px]"
        onInteractOutside={isPending ? (e) => e.preventDefault() : undefined}
      >
        <DialogHeader>
          <DialogTitle>{t("dialogs.deleteList.title")}</DialogTitle>
          <DialogDescription>
            {t("dialogs.deleteList.confirmMessage", { name: reportListName })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            {t("actions.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t("common.loading")}
              </>
            ) : (
              t("actions.delete")
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
